<template>
    <div>
        <h3>順番を変更する</h3>
        <div>
            <h4>小説の順番を変更する</h4>
            <p>
                複数の小説を追加した場合、順番を変更することができます。
            </p>
            <p>
                マイページ＞小説の「順番変更」ボタンで小説の順番変更が実行できます。
                クリックして選択し、移動先をもう一度クリックしてください。
                上下に移動しただけでは順番の変更は確定されません。
                必ず<b>保存</b>で、確定してください。
            </p>
            <img src="/img/help/novel/24.png" alt="順番変更" class="img-thumbnail">
            <p>
                ジャンルに分かれていても、ここで決められた順番通りに本棚に掲載されます。
                作品が束ねられたシリーズの場合、シリーズ内の順位が一番上の代表作品の順位が表示順となります。
            </p>
            <h4>ジャンルの順番を変更する</h4>
            <p>
                ２件以上のジャンルが登録されている場合、その表示順を変更することができます。
            </p>
            <p>
                ジャンル画面で位置を変更したいジャンルの「移動」をクリックし、移動先を再度クリックして順番を変更してください。
                移動しただけでは変更は確定しません。必ず「順番更新」で変更を確定してください。
            </p>
            <h4>シリーズ作品の順番を変更する</h4>
            <p>
                シリーズ作品が２冊以上登録されている場合、並び順を変更することができます。
            </p>
            <p>
                シリーズ＞小説から小説一覧を表示し、位置を変更したい小説の「移動」をクリックして、移動先を再度クリックして順番を変更してください。
                移動しただけでは変更は確定しません。必ず「順番更新」で変更を確定してください。
            </p>
            <h4>シリーズの順番を変更する？</h4>
            <p>
                シリーズ自体の順番も変更可能ですが、予定されていたシリーズ一覧画面が未実装のため、変更しても意味はありません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "小説の順番を変更する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>